// extracted by mini-css-extract-plugin
export default {"component":"UserMessages_component__3Nm1t"};